import { render } from "./SidebarComponent.vue?vue&type=template&id=b2bdc7ee&scoped=true"
import script from "./SidebarComponent.vue?vue&type=script&lang=js"
export * from "./SidebarComponent.vue?vue&type=script&lang=js"

import "./SidebarComponent.vue?vue&type=style&index=0&id=b2bdc7ee&lang=css"
import "./SidebarComponent.vue?vue&type=style&index=1&id=b2bdc7ee&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bdc7ee"]])

export default __exports__